export default __webpack_public_path__ + "static/media/avatar6.5c62f101.jpg";